export const HTTP_CONTENT_TYPE_HEADER_VALUE = 'application/json;charset=UTF-8'

export const HTTP_ACCEPT_HEADER_VALUE = 'application/json'

export const HTTP_PRAGMA_HEADER_VALUE = 'no-cache'

export const HTTP_CACHE_CONTROL_HEADER_VALUE =
   'no-store, no-cache, must-revalidate, private, max-age=0'
